"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = require("@/utils/index");
var _auth = require("@/utils/auth");
var _two = _interopRequireDefault(require("@/components/upload/two"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'replySet',
  components: {
    upload: _two.default
  },
  data: function data() {
    return {
      copyText: _index.copyText,
      form: {
        params: []
      },
      upObj: {
        account_appid: this.$route.query.appid,
        token: (0, _auth.getToken)()
      },
      appid: this.$route.query.appid || '',
      store_id: this.$route.query.store_id || '',
      atStr: ''
    };
  },
  mounted: function mounted() {
    this.getInfo();
    this.getWxxcx();
  },
  methods: {
    /**
     * 获取微信小程序列表
     */
    getWxxcx: function getWxxcx() {
      var _this = this;
      this.$get('WxOpen/getWxList', {
        page: 1,
        limit: 1,
        wx_status: 1
      }).then(function (res) {
        var list = res.list;
        if (list.length > 0) {
          _this.atStr = "<a data-miniprogram-appid=\"".concat(list[0].app_id, "\" data-miniprogram-path=\"pages/index/index?form_public=true").concat(_this.store_id ? '&store_id=' + _this.store_id : '', "\">\u501F\u5145\u7535\u5B9D</a>");
        }
      });
    },
    /**
     * 获取info
     */
    getInfo: function getInfo() {
      var _this2 = this;
      this.$get('commonapi/feedback/wxgz_response_detail', {
        account_appid: this.appid
      }).then(function (res) {
        _this2.form.params = res.params || [];
      });
    },
    /**
     * 提交会员卡信息
     */
    postCard: function postCard() {
      var _this3 = this;
      var url = 'agentapi/feedback/save_wxgz_response',
        form = JSON.parse(JSON.stringify(this.form)),
        params = {
          account_appid: this.appid,
          params: []
        };
      if (form.params) {
        form.params.map(function (item) {
          if (item.content) {
            if (item.type == 'image') {
              var media_id = _this3.arrayKeys(item.content, 'media_id');
              var img_url = _this3.arrayKeys(item.content, 'url');
              params.params.push({
                type: item.type,
                media_id: media_id[0],
                content: [{
                  media_id: media_id[0],
                  url: img_url[0]
                }]
              });
            } else {
              params.params.push({
                type: item.type,
                content: item.content
              });
            }
          }
        });
      }
      console.log(params);
      this.$post(url, params).then(function (res) {
        _this3.$message({
          message: '提交成功',
          type: 'success'
        });
      });
    }
  }
};